import { VerificationPhotosContainer } from '@/components/custom';
import { VerificationAdditionalCheckStatusEnum } from '@/enums';

const ViewDataVerifications = () => (
  <VerificationPhotosContainer
    additionalCheckStatus={VerificationAdditionalCheckStatusEnum.WITH_STATE}
    disableActionInvalidations
    deniedStateChange />
);

export default ViewDataVerifications;
